import React from "react";
import authStore from "./core/auth.store";
import AppStore from "./core/app.store";
import { DefaultLayout } from "./layout";
import { USER_ROLES, AuthRoutes, SuperadminRoutes, AdminRoutes, UserRoutes } from "./routes";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";

class App extends React.Component {
  constructor(props) {
    super(props);
    // Initialize from store so first render uses rehydrated auth (avoids redirect to login then dashboard on refresh)
    this.state = {
      appState: AppStore.getState().app || {},
      auth: authStore.getState().auth_reducer || {},
      sso: authStore.getState().sso_reducer || {},
    };
    this.showMessage = this.showMessage.bind(this);
  }

  componentDidMount() {
    this.setState({ appState: AppStore.getState().app, auth: authStore.getState().auth_reducer, sso: authStore.getState().sso_reducer });
    this.appStrUnsub = AppStore.subscribe(() => this.setState({ appState: AppStore.getState().app }));
    this.authUnsub = authStore.subscribe(() =>
      this.setState({ auth: authStore.getState().auth_reducer, sso: authStore.getState().sso_reducer })
    );
  }

  componentWillUnmount() {
    this.appStrUnsub();
    this.authUnsub();
  }

  showMessage({ msg, type }) {
    toast(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type,
    });
  }

  render() {
    const { appState, auth, sso } = this.state;
    return (
      <DefaultLayout
        appState={appState}
        auth={auth}
        sso={sso}
        userRoles={USER_ROLES}
        authRoutes={AuthRoutes}
        superadminRoutes={SuperadminRoutes}
        adminRoutes={AdminRoutes}
        userRoutes={UserRoutes}
      />
    );
  }
}

export default App;
